export default __webpack_public_path__ + "static/media/icn_login_profile.a7ef133e.svg";